import styled from 'styled-components'
import { media } from '../../../utils/mediaQuery'
import { ScoreVariant } from './TransportScoreCard.types'

export const ScoreCard = styled.div<{ $variant?: ScoreVariant }>`
  padding: 16px;
  border-radius: 10px;
  background: ${({ theme }) => theme.colors.background.secondary};
  border: 1px solid
    ${({ theme, $variant }) => {
      const colors = {
        primary: theme.colors.primary,
        success: theme.colors.success,
        warning: theme.colors.warning,
        danger: theme.colors.danger,
      }
      return colors[$variant || 'primary'] + '30'
    }};
  position: relative;
  overflow: hidden;

  ${media.tabletDown} {
    padding: 16px;
  }
`

export const ScoreHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;

  ${media.tabletDown} {
    margin-bottom: 12px;
  }
`

export const ScoreTitle = styled.h3`
  margin: 0;
  font-size: 13px;
  font-weight: 500;
  color: ${({ theme }) => theme.colors.text.primary};
  display: flex;
  align-items: center;
  gap: 3px;

  ${media.tabletDown} {
    font-size: 14px;
  }
`

export const ScoreValue = styled.div<{ $size?: 'small' | 'medium' | 'large' }>`
  font-size: ${({ $size }) =>
    $size === 'large' ? '38px' : $size === 'medium' ? '26px' : '20px'};
  font-weight: 700;
  color: ${({ theme }) => theme.colors.primary};
  line-height: 1;

  ${media.tabletDown} {
    font-size: ${({ $size }) =>
      $size === 'large' ? '36px' : $size === 'medium' ? '28px' : '20px'};
  }
`

export const ScoreLabel = styled.div`
  font-size: 10px;
  color: ${({ theme }) => theme.colors.text.secondary};
  margin-top: 3px;

  ${media.tabletDown} {
    font-size: 11px;
  }
`
